import { Component, ComponentFactoryResolver, ViewContainerRef, ViewChild } from '@angular/core';
import { BeneListService } from '../../../services/beneList.service';

import { Router, ActivatedRoute } from '@angular/router';
import { ModalRouteService } from '../../../services/modal-route.service';
import { ModalService } from '../../../services/modal.service';

import { BeneFormComponent } from '../bene-form.component';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';

@Component({
  selector: 'bene-form-coverpath',
  templateUrl: './bene-form.component.coverpath.html',
  providers: [BeneListService],
})
export class BeneFormComponentCoverPath extends BeneFormComponent {
  constructor(
    compiler: ComponentFactoryResolver,
    beneListService: BeneListService,
    activatedRouter: ActivatedRoute,
    modalRouteService: ModalRouteService,
    router: Router,
    modalService: ModalService,
    fb: FormBuilder
  ) {
    super(compiler, beneListService, activatedRouter, modalRouteService, router, modalService, fb);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }
}
